if (!customElements.get('energy-rebate')) {
    class EnergyRebate extends HTMLElement {
        productEnergyRebate = new Map();
        localStorageKey = 'userLocationData';
        userLocationData = null;
        energyRebateContainer = '.energy-rebate-container';
        discountEnergyRebateBlock = '.discount-energy-rebate';

        /**
         * Constructor
         */
        constructor() {
            super();
            this.handleEnergyRebateReady = this.handleEnergyRebateReady.bind(this);
            this.handleGeolocationUpdated = this.handleGeolocationUpdated.bind(this);
        }

        /**
         * Add event listeners when the component is added to the DOM.
         */
        connectedCallback() {
            document.addEventListener('productEnergyRebateLoad', this.handleEnergyRebateReady);
            document.addEventListener('geolocation:updated', this.handleGeolocationUpdated);
            document.addEventListener('customer:geolocation:updated', this.handleGeolocationUpdated);
            document.addEventListener('geolocation:preciseLocation', this.handleGeolocationUpdated);
        }

        /**
         * Remove event listeners when the component is removed from the DOM.
         */
        disconnectedCallback() {
            document.removeEventListener('productEnergyRebateLoad', this.handleEnergyRebateReady);
            document.removeEventListener('geolocation:updated', this.handleGeolocationUpdated);
            document.removeEventListener('customer:geolocation:updated', this.handleGeolocationUpdated);
            document.removeEventListener('geolocation:preciseLocation', this.handleGeolocationUpdated);
        }

        /**
         * Handle productEnergyRebateLoad event.
         * @param event
         * @returns {Promise<void>}
         */
        async handleEnergyRebateReady(event) {
            try {
                this.productEnergyRebate = new Map(Object.entries(event.detail.productEnergyRebate));
                await this.initUserLocationData();
            } catch (error) {
                console.error('Error handling productEnergyRebateLoad:', error);
            }
        }

        /**
         * Initialize user location data from localStorage.
         * @returns {Promise<void>}
         */
        async initUserLocationData() {
            try {
                const storedValue = localStorage.getItem(this.localStorageKey);
                this.userLocationData = storedValue ? JSON.parse(storedValue) : null;
            } catch (error) {
                console.error('Error reading user location data from localStorage:', error);
                this.userLocationData = null;
            }

            if (this.userLocationData) {
                this.applyEnergyRebate(this.userLocationData);
            }
        }

        /**
         * Handle geolocation updated event.
         * @param event
         */
        handleGeolocationUpdated(event) {
            try {
                this.userLocationData = event.detail.userLocationData;
                if (this.userLocationData) {
                    this.applyEnergyRebate(this.userLocationData);
                }

            } catch (error) {
                console.error('Error during geolocation update handling:', error);
            }
        }

        /**
         * Apply energy rebate based on user's location data.
         * @param userLocationData
         */
        applyEnergyRebate(userLocationData) {
            if (!userLocationData || !userLocationData.region) {
                console.warn('Invalid or missing region data.');
                return;
            }

            const region = userLocationData.region.trim();

            if (this.productEnergyRebate.has(region)) {
                const rebateValue = parseFloat(this.productEnergyRebate.get(region));
                const formattedRebateValue = '$'+rebateValue.toFixed(2);

                this.showEnergyRebateMessage(region, formattedRebateValue);
            } else {
                this.clearRebateMessage();
            }
        }

        /**
         * Display the energy rebate message.
         * @param region
         * @param rebateValue
         */
        showEnergyRebateMessage(region, rebateValue) {
            const rebateContainerElement = document.querySelector(this.energyRebateContainer);
            const rebateElement = this.querySelector(this.discountEnergyRebateBlock);

            if (rebateElement) {
                rebateElement.innerHTML = `up to <span class="rebate-price">${rebateValue}</span> off at checkout`;
            }

            if (rebateContainerElement) {
                rebateContainerElement.classList.remove('hidden');
            }
        }

        /**
         * Clear the energy rebate message.
         */
        clearRebateMessage() {
            const rebateContainerElement =  document.querySelector(this.energyRebateContainer);
            if (rebateContainerElement) {
                rebateContainerElement.classList.add('hidden');
            }
            const rebateElement = this.querySelector(this.discountEnergyRebateBlock);
            if (rebateElement) {
                rebateElement.textContent = '';
            }
        }
    }

    customElements.define('energy-rebate', EnergyRebate);
}